export default {
  title: "Company details",

  name: {
    title: "Company name",
    input: {
      companyName: "Company name",
    },
    button: {
      save: "Save",
    },
    api: {
      name: {
        patched: "Company name saved",
      },
    },
  },

  address: {
    title: "Address",
    input: {
      street: "Street",
      streetNumber: "Street number",
      streetNumberAddition: "Street number addition",
      postalCode: "Postal code",
      country: "Country",
      city: {
        label: "City",
        required: {
          country: "First select a country",
        },
      },
    },
    button: {
      save: "Save",
    },
    api: {
      patch: {
        success: "Address saved",
      },
    },
  },

  email: {
    title: "Email address",
    input: {
      email: "Email address",
    },
    button: {
      save: "Save",
    },
    api: {
      email: {
        patched: "Email address saved",
      },
    },
  },

  bankAccount: {
    title: "Bank account",
    input: {
      bank: "Bank",
      iban: "IBAN",
      swift: "SWIFT",
      holder: "Holder",
    },
    button: {
      save: "Save",
    },
    api: {
      patched: "Bank account data saved",
    },
  },

  api: {
    name: {
      notNull: "Provide a company name",
    },
  },
}
